import { useMutation, type UseMutationOptions } from "@tanstack/react-query";
import type { Object } from "ts-toolbelt";

import type { CreateProductRequestDto } from "../../dtos/create-product-request-dto";
import type { CreateProductResponseDto } from "../../dtos/create-product-response-dto";
import { ProductService } from "../../services/product-service";

type UsePostCreateProductDraftMutationParams = {
  options?: UseMutationOptions<
    Object.Partial<CreateProductResponseDto, "deep">,
    unknown,
    Object.Partial<CreateProductRequestDto, "deep">
  >;
};

export const usePostCreateProductDraftMutation = ({
  options
}: UsePostCreateProductDraftMutationParams = {}) => {
  return useMutation({
    mutationFn: async (payload) => {
      return await ProductService.createProductDraft({ payload });
    },
    ...options
  });
};
